import { useTheme } from 'next-themes'

const useColorModeValue = <T,>(lightValue: T, darkValue: T): T => {
    const { theme } = useTheme()

    return theme === 'dark' ? darkValue : lightValue
}

export default useColorModeValue
